// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import router from './router'
import comm from './common/js/cofig'
import VueRouter from 'vue-router'
import routes from './router/index'
import ElementUI from 'element-ui'
import './styles/comm.css'
import axios from 'axios'; 
import locale from 'element-ui/lib/locale/lang/en'
import {server} from './api/api'

Vue.use(ElementUI, { locale })
// Vue.use(ElementUI) 
Vue.use(VueRouter)
Vue.use(comm)
// axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios
// Vue.prototype.$http = axios
Vue.config.productionTip = false

console.log(routes)
console.log(server)
const router = new VueRouter({
  routes:routes
})
// const service = axios.create({
//   // 超时
//   timeout: 10000
// })

router.beforeEach((to, from, next) => {
  if(to.path=="/"){
    // next('/home');
    next('/home/index');
    return false
  }
  if (to.path == '/Login') {
    // sessionStorage.removeItem('user');
  }
//判断存不存在token，不存在返回登录界面
  var token = JSON.parse(localStorage.getItem('key'));
  // if(!token && to.path != '/login'){
  //   next({path:'/login'});
  //   return false
  // }else{
    // console.log(token)
    if(token){
      server.interceptors.request.use(
        config => {
          // console.log(config);
          // if(token){
          //   token = JSON.parse(localStorage.getItem('token'))
          //   // config.headers.token = token;
          // }else {}
          config.headers.token = JSON.parse(localStorage.getItem('key'));
          return config;
        },err => {
          return Promise.reject(err);
        })
        server.interceptors.response.use(function (response) {
          // console.log(response)
          if(response.data.code == 401){
            // console.log('token失效');
            // localStorage.removeItem('token')
            localStorage.clear()
            Vue.prototype.$message({
              message: 'Login expired',
              type: 'warning'
            });
            next('/login');
          }
          // 处理响应数据
          return response;
        }, function (error) {
          // 处理响应失败=
          console.log(error.response)
          if(error.response && error.response.data.code == 401){
             Vue.prototype.$message({
                // message: 'Not connected to server',
                message: error.response.data.msg,
                type: 'warning'
              });
              next('/login');
          }
          return Promise.reject(error);
        });
    }else{
      if (to.path === '/login') {
        next();
      } else {
        next('/login');
      }
    }
    
    // console.log(token)
    // console.log(to)

    if (to.matched.length === 0) { //如果未匹配到路由
      from.name ? next({
        name: from.name
      }) : next(to); //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    } else {
      next(); //如果匹配到正确跳转
    }
  // }
   
  
})
/* eslint-disable no-new */
new Vue({
  // el: '#app',
  router,
  components: {
    comm
  },
  // components: { App },
  // template: '<App/>'
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js